import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'


export default function WaterSupplyDistributionNetworkPreventiveWorkPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, handleIsPost, apiFlag, rowData } = props

    // const [rowData, setRowData] = useState(Flag === 'Update' ? rowData : '')
    const [IsOpen, setIsOpen] = useState(false)


    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })
    // const [LocationName, setLocationName] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })
    // const [PipeSize, setPipeSize] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })
    // const [IncomingYesterdayReading, setIncomingYesterdayReading] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })
    // const [OutgoingYesterdayReading, setOutgoingYesterdayReading] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Quantity</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">

                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date :</b></label>
                                        <input type="date" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-4" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Prabhag No :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='wardName'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Location Name :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='locationName'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

                                <h5 className='mt-2'>Water Consumption</h5>
                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Metered :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='pipeSize'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Unmetered :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='pipeSize'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

<h5 className='mt-2'>Supply Scheduled Time</h5>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Stipulated Morning  :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Stipulated Evening  :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='pipeSize'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Actual Morning  :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Actual Evening   :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <h5 className='mt-2'>Quantified of Critical Point</h5>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Required :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Actual :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <h5 className='mt-2'>No of Critical Point</h5>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Normal   :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Affected :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns  ms-2 mr-2 float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}